function create_chemicals_chart () {
    $("#chemicals_refilter_trig").click(function(){
        loader_asynchronous(function(){
            $(".chemicals_filter_title").html('全市');
			if ($("#chemicals_heatmap").hasClass("bg-primary")) {
				map.removeLayer(overlay_dataset["temp_map"])
			} else { map_redraw(undefined) }
			chemicals_bar({destroy: true});
            map.setView([25.038169, 121.557588], 11);
            setTimeout(function(){
                map.panBy([-80, 0]);
            }, 1000);
        });
    });
	$("#chemicals_points").click(() => {
		if ($("#chemicals_points").hasClass("bg-primary")) return
		$("#chemicals_points").addClass("bg-primary")
		$("#chemicals_heatmap").removeClass("bg-primary")
		$("#ovarlay_list_filter").find("input").val("火災決策").keyup()
		$("#ovarlay_list tbody").find("tr").eq(3).click()
		$("#ovarlay_list tbody").find("tr").eq(4).click()
	})
	$("#chemicals_heatmap").click(() => {
		if ($("#chemicals_heatmap").hasClass("bg-primary")) return
		$("#chemicals_heatmap").addClass("bg-primary")
		$("#chemicals_points").removeClass("bg-primary")
		$("#ovarlay_list_filter").find("input").val("火災決策").keyup()
		$("#ovarlay_list tbody").find("tr").eq(3).click()
		$("#ovarlay_list tbody").find("tr").eq(4).click()
	})
	const data = raw_data["chemicals"]
	
    chemicals_bar({destroy: false});

    function chemicals_bar(table_setting){
        var chemical_number = {}, 
			chemical_type = {},
			chemical_coor = {},
			each_row_data = [],
            each_row_data_export = [];

        if (table_setting.destroy) {
            var table = $('#chemicals_list').DataTable();
            table.destroy();
            $("#chemicals_list tbody").empty();
        };

		data.features.forEach(function(el){
			// chemicals region stat
			if (chemical_number[el.properties.region] == undefined) {
				chemical_number[el.properties.region] = { sum: 0 };
			}
			chemical_number[el.properties.region].sum += 1;
			
			var lat = parseFloat(el.geometry.coordinates[1]);
			var lng = parseFloat(el.geometry.coordinates[0]);

			each_row_data.push([el.properties.region, el.properties.PCompAddr.slice(6), el.properties.PCompName, 
                Array.from(new Set(el.properties.toxic_chemicals.map(el => el.ATCName))).join(","),
                Array.from(new Set(el.properties.other_chemicals.map(el => el.ChemicalsName))).join(",")
            ]);
			each_row_data_export.push([el.properties.region, el.properties.PCompAddr.slice(6), el.properties.PCompName, 
                Array.from(new Set(el.properties.toxic_chemicals.map(el => el.ATCName))).join(","),
                Array.from(new Set(el.properties.other_chemicals.map(el => el.ChemicalsName))).join(","), 
                lat, lng
            ]);
			// 點擊表格，找到地圖上的點位(座標提供)
			chemical_coor[el.properties.PCompAddr.slice(6)] = [lat, lng];
		})

        // data processing
        var toxic_chemicals_sorted = Object.keys(chemical_number).sort((a, b) => 
			chemical_number[b].sum - chemical_number[a].sum);
		var chart_array = [], chart_array_name = []
        toxic_chemicals_sorted.forEach(function(el){
            chart_array.push(chemical_number[el].sum);
            chart_array_name.push(el.slice(0,2));
        });
		
        // chart
        Highcharts.chart('chemicals_bar_chart', {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: chart_array_name,
                labels: {
                    step: 1,
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)',
                        fontSize: '16px'
                    },
                    useHTML: true,
                    formatter: function(){
                        var string = this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2)
                        return string;
                    }
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: ''
                },
                labels: {
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)'
                    }                    
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)'
                    }
                }
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '<span style="color:{series.color};">{series.name}</span>: <b>{point.y}處</b> ({point.percentage:.0f}%)<br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false,
                        color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                    }
                },
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
							// 長條圖點擊事件(篩選行政區) >> 表格、地圖點位連動
                            click: function () {
                                var filter_region = this.category + "區";
                                $(".chemicals_filter_title").html(filter_region)
                                // table
                                table_redraw_region(filter_region);
                                // map
								if (!$("#chemicals_heatmap").hasClass("bg-primary")) {
									map_redraw(filter_region)
								}
								region_focus(filter_region)
                            }
                        }
                    }
                }
            },
            series: [{
                name: '儲存場所數量',
                color: 'rgba(58, 197, 105, 1)',
                data: chart_array
            }]
        });

        // table
        $('#chemicals_list').DataTable({
            "data": each_row_data,
            "deferRender": true,
            "order": [[ 3, "desc" ]],
            "searching": true
        });
		// 點擊表格，找到地圖上的點位並zoom in
        $("#chemicals_list tbody").on("click", "tr", function(){
            var coor_array = chemical_coor[$(this).find("td").eq(1).html()];
            map.setView(coor_array, 20);
        });

        $("#chemicals_download").click(function(){
            each_row_data_export.unshift(["行政區","地址","儲存場所","毒化物名稱","其他化學品名稱"]);
            downloadxlsx("毒化物與其他化學品.xlsx", ["災情列表"], [each_row_data_export]);
        });
    }

	var original_data = data.features.map(el => [ el.properties.region, el.properties.PCompAddr.slice(6), el.properties.PCompName, 
        Array.from(new Set(el.properties.toxic_chemicals.map(el => el.ATCName))).join(","),
        Array.from(new Set(el.properties.other_chemicals.map(el => el.ChemicalsName))).join(",") 
    ])
    function table_redraw_region(filter_region){
        let table = $('#chemicals_list').DataTable();
		let filtered_data = original_data.filter(el => el[0] == filter_region)
		table.clear().rows.add(filtered_data).draw()
    }

    function map_redraw(filter_region){
		$("#map_clear").click();
		backgroud_layer_control("狹小巷道火災搶救不易地區");
        backgroud_layer_control("高危險建築物-點位圖");
		chemicals_filter['region'] = filter_region
		backgroud_layer_control("毒化物與其他化學品-點位圖");
    }

	function region_focus(target) {
		var target_geojson;
		overlay_dataset["Basic_map"].features.forEach(function(el){
			if (el.properties.TOWNNAME == target) {
				target_geojson = el;
			}
		})
		if (overlay_dataset["temp_map"] != undefined) {
			map.removeLayer(overlay_dataset["temp_map"]);
		}
		overlay_dataset["temp_map"] = L.geoJson(target_geojson,{
			color: "blue",
			weight: 3,
			fill: false,
			interactive: false
		}).addTo(map);
		map.fitBounds(overlay_dataset["temp_map"].getBounds());
		setTimeout(function(){
			map.panBy([-90, 0]);
		}, 500);
	}
}